<script setup>
import { ref } from "vue";
import ArgonDetail from "@/components/detail/ArgonDetailLayout.vue";
import UploadLogo from "./UploadLogo.vue";
import AccountSettings from "./AccountSettings.vue";

const actions = ref();
const events = {};

function triggerEvent(action) {
  try {
    events[action.event]();
  } catch {
    console.log("Evento no implementado");
  }
}
</script>

<template>
  <div class="card h-100">
    <div class="card-body">
      <argon-detail :group-actions="actions" @click="triggerEvent">
        <template #body>
          <div class="row spacing">
            <div class="col-12 col-xl-6 mb-6 mb-xl-0">
              <upload-logo />
            </div>
            <div class="col-12 col-xl-6 mb-6 mb-xl-0">
              <account-settings />
            </div>
          </div>
        </template>
      </argon-detail>
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>
